import { searchFieldOptionList, userLevelOptionList, userStatusOptionList, } from '@/constants/userManagement';
import { whereOperators } from '@/lib/query-parameter/filter';
import { userPermission } from '@/constants';
import { permissionSettingRequiredLevelList } from '@/constants/userPermissionSetting/permissionSettingRequiredLevelList';
import { userGetterType } from '@/vuex-store/user/getters';
const vuexGetters = {
    getterIsPermissionSettingPermitted: (state, getters, rootState, rootGetters) => {
        const userLevel = rootGetters[userGetterType.userLevel];
        const getterUserPermission = rootGetters['user/getterUserPermission']([
            userPermission.P_UPDATE_USER_PERMISSION,
        ]);
        if (!permissionSettingRequiredLevelList.includes(userLevel)) {
            return false;
        }
        if (!getterUserPermission) {
            return false;
        }
        return true;
    },
    getterPageSize: ({ filterOption }) => Number(filterOption.pageSizeType),
    getterPageSizeType: ({ filterOption }) => filterOption.pageSizeType,
    getterUserStatusType: ({ filterOption }) => filterOption.userStatusType,
    getterUserLevel: ({ filterOption }) => filterOption.userLevel,
    getterUserList: ({ userList }) => userList ?? [],
    getterUserLevelList: (state, getters, rootState, rootGetters) => {
        const onlyHub = [
            '30',
            '31',
            '32',
        ];
        const isDistUser = rootGetters[userGetterType.isDistUser];
        if (!isDistUser) {
            const filtered = userLevelOptionList
                .filter((item) => onlyHub.includes(item.value) || item.value === 'ALL');
            return filtered;
        }
        return userLevelOptionList;
    },
    getterPaginationData: ({ paginationData }) => {
        const { pageNumber, pages, } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
    getterUserTotalLength: ({ paginationData }) => paginationData.total,
    getterSearchFieldTypeParam: ({ filterOption }) => {
        const [ID, NAME,] = searchFieldOptionList;
        const { value, field } = filterOption.searchWord;
        return {
            [ID.value]: [
                {
                    condition: whereOperators.like,
                    field: ID.field,
                    value,
                },
            ],
            [NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: NAME.field,
                    value,
                },
            ],
        }[field];
    },
    getterUserStatusTypeParam: ({ filterOption }) => {
        const [ALL, OK, LEAVE, STOP,] = userStatusOptionList;
        const { userStatusType } = filterOption;
        return {
            [OK.value]: [
                {
                    condition: whereOperators.equals,
                    field: OK.field,
                    value: OK.value,
                },
            ],
            [LEAVE.value]: [
                {
                    condition: whereOperators.equals,
                    field: LEAVE.field,
                    value: LEAVE.value,
                },
            ],
            [STOP.value]: [
                {
                    condition: whereOperators.equals,
                    field: STOP.field,
                    value: STOP.value,
                },
            ],
            [ALL.value]: [],
        }[userStatusType];
    },
    getterUserLevelParam: ({ filterOption }) => {
        const [ALL,] = userLevelOptionList;
        const { userLevel } = filterOption;
        return {
            42: [
                {
                    condition: whereOperators.equals,
                    field: 'level',
                    value: '42',
                },
            ],
            41: [
                {
                    condition: whereOperators.equals,
                    field: 'level',
                    value: '41',
                },
            ],
            40: [
                {
                    condition: whereOperators.equals,
                    field: 'level',
                    value: '40',
                },
            ],
            32: [
                {
                    condition: whereOperators.equals,
                    field: 'level',
                    value: '32',
                },
            ],
            31: [
                {
                    condition: whereOperators.equals,
                    field: 'level',
                    value: '31',
                },
            ],
            30: [
                {
                    condition: whereOperators.equals,
                    field: 'level',
                    value: '30',
                },
            ],
            [ALL.value]: [
                // 상점, 시스템은 목록에서 제외 + 72, 80 레벨도 제외
                // TODO: 다음 운영에서 백엔드에서 필터링 해주시기로 함 = 제거될 필터
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '10',
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '20',
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '21',
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '22',
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '70',
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '71',
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '72',
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'level',
                    value: '80',
                },
            ],
        }[userLevel];
    },
    getterSearchValue: ({ filterOption }) => filterOption.searchWord.value,
    getterSearchField: ({ filterOption }) => filterOption.searchWord.field,
};
export default vuexGetters;
